import React from "react";
import Accordions from "../../../components/Accordions";

const Sem1Cse1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1yYSCO5k4ArLbQ8olBPhxvMeiq4thjsqW/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1oCj9n8oWbdXm8UeKYrBOKYdq9M4rnsY7/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1O13Nz7F3e64gv50_W0v11VfvtpQ6xCrQ/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">CSE Sem - 1</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem1Cse1;
